import React, { useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import DefaultAccordion from "../../../../components/accordion/defaultAccordion";
import toast from "react-hot-toast";
import { getHelpCenterCategoryDetail } from "../../../../../services/workspace/helpCenterCategory.service";
import { useParams } from "react-router-dom";
import HelpCenterSearch from "../../components/helpCenterSearch";

const items = [
  { label: "Home", path: "/" },
  { label: "Help Center", path: "/help" },
  { label: "Detail", path: "" },
];

function DetailPage() {
  const { id } = useParams();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    setLoading(true);
    getHelpCenterCategoryDetail(id)
      .then((response) => {
        const fetchedQuestions = response.questions || [];
        const questionData = fetchedQuestions.map((item) => ({
          title: item.question,
          content: item.answer,
          link: item.link,
        }));
        setData(questionData);
        setFilteredData(questionData);
      })
      .catch((error) => {
        toast.error("Failed to fetch the category data!");
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);
  useEffect(() => {
    if (search.trim() !== "") {
      const filtered = data.filter((item) => {
        return (
          item.title.toLowerCase().includes(search.toLowerCase()) ||
          item.content.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [search, data]);

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      <div className="flex flex-col gap-4 bg-white p-4 text-theme h-[calc(100vh-160px)]">
        {/* <div className="flex flex-row gap-2 text-theme font-bold items-center">
          <div className="bg-light rounded-md flex flex-col gap-2 items-center justify-center min-h-40 w-full">
            <h2 className="font-bold text-md">Welcome To School Help Centre</h2>
            <GlobalSearch
              classnames={"bg-white border-none !w-96 font-normal"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div> */}
        <HelpCenterSearch />
        <div>
          <p className="font-bold text-md">Got Questions? We've Got Answers!</p>
          <p className="text-textLight">
            Get Clarifications on Commonly Asked Questions, Exploring Everything
            You Need to Know About School ERP.
          </p>
        </div>
        <div className="overflow-y-auto">
          {loading ? (
            <Loading />
          ) : (
            <DefaultAccordion
              data={filteredData}
              customClasses={{
                accordionClass: "bg-white",
                panelClass: "shadow-md",
                titleClass: "text-theme",
                contentClass: "text-primary-50",
                indexClass: "bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6]",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

const Loading = () => {
  return (
    <div className="flex flex-col gap-2">
      <div className="animate-pulse space-y-2 border-b py-3">
        <div className="h-6 bg-bghoverlight rounded w-2/3"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
        <div className="h-4 bg-bghoverlight rounded w-2/4"></div>
      </div>
      <div className="animate-pulse space-y-2 border-b py-3">
        <div className="h-6 bg-bghoverlight rounded w-2/3"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
      </div>
      <div className="animate-pulse space-y-2 py-3">
        <div className="h-6 bg-bghoverlight rounded w-3/4"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
        <div className="h-4 bg-bghoverlight rounded w-full"></div>
      </div>
    </div>
  );
};
export default DetailPage;
